import {
  toLakh,
  sumThis,
  numberWithCommas,
  toCurrency,
  sumOf,
  countOf,
  sumAndCountOf,
  showSum,
  showCount,
  showSumAndCount,
  percentChange,
  showBlank,
  changeClassTo,
  mobileNumber,
  panCardNumber,
  validEmail,
  adharNumber,
  allDirectQueries
} from "../../commonFunctions";
import { controls } from "../../controls";


const specialinstruction = {
  label: "Special Instruction",
  pageLabel: "Special Instruction",
  starting: true,
  url: "specialinstruction",
  pageType: "history",
  formState: { checked: "view" },
  formActions: { edit: { allow: true }, delete: { allow: true } },
  // "Address.",
  form: [
    ...controls.displayText({ star: true, label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ isRequired: true, width: "col-sm-4" }),
    ...controls.showData({ data: "branch_display", name: "branch_display", width: "col-sm-4" }),
    ...controls.displayText({ width: "col-sm-2" }),
    ...controls.displayText({ star: true, label: "GL Sub Head", width: "col-sm-2" }),
    ...controls.product({ isRequired: true, star: true, width: "col-sm-4" }),
    ...controls.showData({ data: "product_code_display", name: "product_code_display", width: "col-sm-4" }),
    ...controls.displayText({ width: "col-sm-2" }),
    ...controls.displayText({ label: "Account No.", width: "col-sm-2" }),
    ...controls.numberOnly({ placeHolder: "Enter Account No", name: "account_number", width: "col-sm-4" }),
    ...controls.displayText({ width: "col-sm-6" }),
    ...controls.magicDateLabel({ label: "From Date", width: "col-sm-2" }),
    ...controls.magicDate({ dateType: "ontype", name: "form_date", width: "col-sm-4" }),
    ...controls.magicDateLabel({ label: "To Date", width: "col-sm-2" }),
    ...controls.magicDate({ dateType: "ontype", name: "to_date", width: "col-sm-4" }),


    ...controls.displayText({ label: "# of Records", width: "col-sm-2" }),
    ...controls.numberOnly({ placeHolder: "# of Records", name: "per_page", width: "col-sm-4" }),
    ...controls.checkBox({ isRequired: true, star: true, default: true, name: "isActive", label: "Active", width: "col-sm-4" }),

  ]
}

export default specialinstruction;